import { listProductCategory } from "../mock/mockData";

const actions = {
  async listEndorsement(context, payload) {
    try {
      const response = await this.$api.call("pl_endorsement.list", payload);
      if (response.data === null) {
        response.data = [];
      }
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationEndorsements", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationEndorsements", responseData);
      }

      context.commit("mutationEndorsementsMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationEndorsement", []);
      context.commit("mutationEndorsementsMeta", {});

      throw error;
    }
  },

  async listPartner(context, payload) {
    try {
      const response = await this.$api.call("pl_endorsement.partners", payload);
      const responseData = response.data;

      context.commit("mutationPartners", responseData);

      return response;
    } catch (error) {
      context.commit("mutationPartners", []);
      throw error;
    }
  },

  async listProductCategory(context) {
    try {
      // TODO: hide for temporary, needs to hardcode for personal lines category
      // const response = await this.$api.call('pl_endorsement.productCategories', payload);
      const response = listProductCategory;
      context.commit("mutationProductCategories", response.data);
      return response;
    } catch (error) {
      context.commit("mutationProductCategories", {});
      throw error;
    }
  },

  async downloadAllPersonalLine(_context, payload) {
    try {
      const response = await this.$api.call("pl_endorsement.export", payload);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default actions;
